import { useMemo } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import IconButton from "@mui/material/IconButton";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

// Según la versión de pdfmake, puede funcionar una de estas dos formas.
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

const HEADERS_DETALLE = [
  {
    label: "Expediente",
    type: "number",
  },
  {
    label: "Fecha de inicio",
    type: "date",
  },
  {
    label: "Temática",
    type: "text",
  },
  {
    label: "Generado por",
    type: "text",
  },
  {
    label: "Asunto",
    type: "text",
  },
];

const HEADERS_DETALLE2 = [
  {
    label: "Expediente",
    type: "number",
  },
  {
    label: "Fecha de inicio",
    type: "date",
  },
  {
    label: "Temática",
    type: "text",
  },
  {
    label: "Se encuentra en",
    type: "text",
  },
  {
    label: "Asunto",
    type: "text",
  },
];

const HEADERS_RESUMEN = [
  {
    label: "Temática",
    type: "text",
  },
  {
    label: "Tipo trámite",
    type: "text",
  },
  {
    label: "Cantidad",
    type: "number",
  },
];

const obtenerAlineacion = (type) => {
  switch (type) {
    case "number":
      return "right";

    case "date":
      return "center";

    case "text":
    default:
      return "left";
  }
};
/* const agruparDatosNoSignificativos = (
  datos,
  umbralPorcentaje = 1.5
) => {
  const total = datos.reduce(
    (acumulado, item) =>
      acumulado + item.cantidad,
    0
  );

  if (total <= 0) {
    return datos;
  }

  const significativos = [];
  let cantidadOtros = 0;

  let digital=false;
  let papel=false;
  datos.forEach((item) => {
    const porcentaje =
      (item.cantidad / total) * 100;

    if (porcentaje < umbralPorcentaje) {
      if(item.digital==="Digital"){
        digital=true;
      }
      if(item.digital==="Papel"){
        papel=true;
      }
      cantidadOtros += item.cantidad;
    } else {
      significativos.push(item);
    }
  });

  if (cantidadOtros > 0) {
    significativos.push({
      tematica: "Trámites de baja frecuencia",
      digital: papel===true && digital===true?"Ambos":papel===true && digital===false?"Papel":papel===false && digital===true?"Digital":"",
      cantidad: cantidadOtros,
    });
  }

  return significativos;
}; */
/* const agruparDatosNoSignificativos = (
  datos,
  maximoSectores = 10
) => {
  const total = datos.reduce(
    (acumulado, item) =>
      acumulado + Number(item.cantidad || 0),
    0
  );

  if (total <= 0) {
    return {
      datos,
      cantidadAgrupados: 0,
      umbralPorcentaje: 0,
    };
  }

 
  const datosOrdenados = datos
    .map((item) => {
      const cantidad =
        Number(item.cantidad || 0);

      return {
        ...item,
        cantidad,
        porcentaje:
          (cantidad / total) * 100,
      };
    })
    .sort(
      (a, b) =>
        b.cantidad - a.cantidad
    );

  
  if (
    datosOrdenados.length <=
    maximoSectores
  ) {
    return {
      datos: datosOrdenados,
      cantidadAgrupados: 0,
      umbralPorcentaje: 0,
    };
  }

  
  const maximoIndividuales =
    maximoSectores - 1;

  const significativos =
    datosOrdenados.slice(
      0,
      maximoIndividuales
    );

  const noSignificativos =
    datosOrdenados.slice(
      maximoIndividuales
    );

  const cantidadOtros =
    noSignificativos.reduce(
      (acumulado, item) =>
        acumulado + item.cantidad,
      0
    );

  const tieneDigital =
    noSignificativos.some(
      (item) =>
        item.digital === "Digital"
    );

  const tienePapel =
    noSignificativos.some(
      (item) =>
        item.digital === "Papel"
    );

  significativos.push({
    tematica:
      "Trámites de baja frecuencia",

    digital:
      tieneDigital && tienePapel
        ? "Ambos"
        : tienePapel
          ? "Papel"
          : tieneDigital
            ? "Digital"
            : "",

    cantidad: cantidadOtros,

    porcentaje:
      (cantidadOtros / total) * 100,
  }); 

  
  const umbralPorcentaje =
    noSignificativos[0]
      ?.porcentaje || 0;

  return {
    datos: significativos,
    cantidadAgrupados:
      noSignificativos.length,
    umbralPorcentaje,
  };
};*/
const filtrarDatosSignificativos = (
  datos,
  umbralPorcentaje = 2.5
) => {
  const total = datos.reduce(
    (acumulado, item) =>
      acumulado + Number(item.cantidad || 0),
    0
  );

  if (total <= 0) {
    return {
      datos: [],
      cantidadOmitidos: 0,
      totalOmitido: 0,
      porcentajeOmitido: 0,
    };
  }

  const datosConPorcentaje =
    datos
      .map((item) => {
        const cantidad =
          Number(item.cantidad || 0);

        return {
          ...item,
          cantidad,
          porcentaje:
            (cantidad / total) * 100,
        };
      })
      .sort(
        (a, b) =>
          b.cantidad - a.cantidad
      );

  const datosSignificativos =
    datosConPorcentaje.filter(
      (item) =>
        item.porcentaje >=
        umbralPorcentaje
    );

  const datosOmitidos =
    datosConPorcentaje.filter(
      (item) =>
        item.porcentaje <
        umbralPorcentaje
    );

  const totalOmitido =
    datosOmitidos.reduce(
      (acumulado, item) =>
        acumulado + item.cantidad,
      0
    );

  return {
    datos: datosSignificativos,
    cantidadOmitidos:
      datosOmitidos.length,
    totalOmitido,
    porcentajeOmitido:
      (totalOmitido / total) * 100,
  };
};
const dibujarTextoEnLineas = ({
  ctx,
  texto,
  x,
  y,
  anchoMaximo,
  maximoLineas = 2,
  altoLinea = 14,
}) => {
  const palabras = String(texto ?? "")
    .trim()
    .split(/\s+/);

  const lineas = [];
  let lineaActual = "";

  palabras.forEach((palabra) => {
    const lineaPrueba = lineaActual
      ? `${lineaActual} ${palabra}`
      : palabra;

    if (
      ctx.measureText(lineaPrueba).width <=
      anchoMaximo
    ) {
      lineaActual = lineaPrueba;
      return;
    }

    if (lineaActual) {
      lineas.push(lineaActual);
    }

    if (
      ctx.measureText(palabra).width >
      anchoMaximo
    ) {
      let palabraRecortada = palabra;

      while (
        palabraRecortada.length > 0 &&
        ctx.measureText(
          `${palabraRecortada}...`
        ).width > anchoMaximo
      ) {
        palabraRecortada =
          palabraRecortada.slice(0, -1);
      }

      lineas.push(`${palabraRecortada}...`);
      lineaActual = "";
    } else {
      lineaActual = palabra;
    }
  });

  if (lineaActual) {
    lineas.push(lineaActual);
  }

  const lineasVisibles =
    lineas.slice(0, maximoLineas);

  if (lineas.length > maximoLineas) {
    let ultimaLinea =
      lineasVisibles[maximoLineas - 1] ?? "";

    while (
      ultimaLinea.length > 0 &&
      ctx.measureText(
        `${ultimaLinea}...`
      ).width > anchoMaximo
    ) {
      ultimaLinea =
        ultimaLinea.slice(0, -1);
    }

    lineasVisibles[maximoLineas - 1] =
      `${ultimaLinea}...`;
  }

  lineasVisibles.forEach(
    (linea, indice) => {
      ctx.fillText(
        linea,
        x,
        y + indice * altoLinea
      );
    }
  );
};

const generarGraficoTortaPorcentual = (
  titulo,
  datos = [],
  total = 0,
  umbralPorcentaje = 2.5,
) => {
  const coloresPaleta = [
    "#4CAF50",
    "#2196F3",
    "#FF9800",
    "#9C27B0",
    "#E53935",
    "#00BCD4",
    "#FFEB3B",
    "#EA4335",
    "#20B2AA",
    "#A0522D",
    "#3F51B5",
    "#7FFF00",
    "#FFC0CB",
    "#001F3F",
    "#228B22",
    "#D4AF37",
    "#9E9E9E",
  ];

  const datosNormalizados = datos
    .map((item) => ({
      tematica:
        String(item.tematica ?? "").trim() ||
        "Sin temática",
      digital:item.digital,
      cantidad:
        Number(item.cantidad) || 0,
    }))
    .filter((item) => item.cantidad > 0);

 /*  const datosFiltrados =
    agruparDatosNoSignificativos(
      datosNormalizados,
      maximoSectores
    ).datos; */
    const datosFiltrados=
    filtrarDatosSignificativos(
      datosNormalizados,
      umbralPorcentaje
    ).datos;
  const totalCalculado =
    datosFiltrados.reduce(
      (acumulado, item) =>
        acumulado + item.cantidad,
      0
    );

  const totalGeneral =
    Number(total) > 0
      ? Number(total)
      : totalCalculado;

  let cantidadColumnas = 1;

  if (datosFiltrados.length > 24) {
    cantidadColumnas = 3;
  } else if (datosFiltrados.length > 10) {
    cantidadColumnas = 2;
  }

  const elementosPorColumna = Math.ceil(
    datosFiltrados.length /
      cantidadColumnas
  );

  const anchoLogico = 760;

const tituloY = 35;
const totalY = 62;

const centerX = anchoLogico / 2;
const centerY = 280;
const radius = 200;

const inicioLeyendasY = 500;
const altoPorLeyenda = 42;
const margenInferior = 35;

const altoLogico = Math.max(
  800,
  inicioLeyendasY +
    elementosPorColumna * altoPorLeyenda +
    margenInferior
);

  const escala = 2;

  const canvas =
    document.createElement("canvas");

  canvas.width =
    anchoLogico * escala;

  canvas.height =
    altoLogico * escala;

  const ctx =
    canvas.getContext("2d");

  if (!ctx) {
    return null;
  }

  ctx.scale(escala, escala);

  ctx.fillStyle = "#FFFFFF";

  ctx.fillRect(
    0,
    0,
    anchoLogico,
    altoLogico
  );

  ctx.font = "bold 18px Arial";
  ctx.fillStyle = "#000000";
  ctx.textAlign = "center";
  ctx.textBaseline = "alphabetic";

  ctx.fillText(
    titulo,
    anchoLogico / 2,
    tituloY
  );

  if (
    datosFiltrados.length === 0 ||
    totalCalculado <= 0 ||
    totalGeneral <= 0
  ) {
    ctx.font = "14px Arial";
    ctx.fillStyle = "#555555";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillText(
      "No hay datos para mostrar",
      anchoLogico / 2,
      altoLogico / 2
    );

    return canvas.toDataURL(
      "image/png"
    );
  }

  const colores =
    datosFiltrados.map(
      (item, index) => {
        /*
         * Se reserva gris para Otros.
         */
        if (item.tematica === "Trámites de baja frecuencia") {
          return "#9E9E9E";
        }

        return coloresPaleta[
          index %
            (coloresPaleta.length - 1)
        ];
      }
    );

  const labels =
    datosFiltrados.map((item) => {
      const porcentaje =
        (item.cantidad /
          totalCalculado) *
        100;

      return `${item.tematica} (${item.digital==="Ambos"?"Papel y Digital":item.digital}) ${item.cantidad} - ${porcentaje.toFixed(
        1
      )}%`;
     
    });
    
  let startAngle =
    -Math.PI / 2;

  datosFiltrados.forEach(
    (item, index) => {
      const sliceAngle =
        (item.cantidad /
          totalCalculado) *
        Math.PI *
        2;

      ctx.beginPath();
      ctx.moveTo(
        centerX,
        centerY
      );

      ctx.arc(
        centerX,
        centerY,
        radius,
        startAngle,
        startAngle + sliceAngle
      );

      ctx.closePath();

      ctx.fillStyle =
        colores[index];

      ctx.fill();

      ctx.strokeStyle =
        "#FFFFFF";

      ctx.lineWidth = 2;
      ctx.stroke();

      const porcentaje =
        (item.cantidad /
          totalCalculado) *
        100;

      if (porcentaje >= 5) {
        const middleAngle =
          startAngle +
          sliceAngle / 2;

        const distanciaTexto =
          radius * 0.83;

        const textX =
          centerX +
          Math.cos(middleAngle) *
            distanciaTexto;

        const textY =
          centerY +
          Math.sin(middleAngle) *
            distanciaTexto;

        ctx.fillStyle =
          "#FFFFFF";

        ctx.font =
          "bold 12px Arial";

        ctx.textAlign =
          "center";

        ctx.textBaseline =
          "middle";

        ctx.fillText(
          `${porcentaje.toFixed(1)}% ${item.digital==="Ambos"?" - P y D":item.digital==="Digital"?" - D":""}`,
          textX,
          textY
        );
      }

      startAngle += sliceAngle;
    }
  );

  ctx.font = "12px Arial";
  ctx.textAlign = "left";
  ctx.textBaseline = "top";

  const margenX = 30;

  const separacionColumnas =
    25;

  const espacioSeparaciones =
    separacionColumnas *
    (cantidadColumnas - 1);

  const anchoDisponible =
    anchoLogico -
    margenX * 2 -
    espacioSeparaciones;

  const anchoColumna =
    anchoDisponible /
    cantidadColumnas;

  const boxSize = 12;

  const espacioEntreCajaYTexto =
    7;
    
    labels.forEach((label, index) => {
      const columna = Math.floor(index / elementosPorColumna);
      const fila = index % elementosPorColumna;
    
      const currentX =
        margenX +
        columna * (anchoColumna + separacionColumnas);
    
      const currentY =
        inicioLeyendasY +
        fila * altoPorLeyenda;
    
      ctx.fillStyle = colores[index];
    
      ctx.fillRect(
        currentX,
        currentY + 2,
        boxSize,
        boxSize
      );
    
      ctx.fillStyle = "#333333";
    
      dibujarTextoEnLineas({
        ctx,
        texto: label,
        x: currentX + boxSize + espacioEntreCajaYTexto,
        y: currentY,
        anchoMaximo:
          anchoColumna -
          boxSize -
          espacioEntreCajaYTexto -
          5,
        maximoLineas: 2,
        altoLinea: 14,
      });
    });
    
    // Texto aclaratorio debajo de las leyendas
    const cantidadFilasLeyenda = Math.min(
      labels.length,
      elementosPorColumna
    );
    
    const textoAclaratorioY =
      inicioLeyendasY +
      cantidadFilasLeyenda * altoPorLeyenda +
      7;
    
    ctx.fillStyle = "#555555";
    ctx.font = "italic 12px Arial";
    const datosaux=
    filtrarDatosSignificativos(
      datosNormalizados,
      2.5
    );
    const textoAclaratorio =
    datosaux.cantidadOmitidos > 0
    ? `Para facilitar la lectura, el gráfico muestra únicamente los tipos de trámite cuya participación es igual o superior al ${umbralPorcentaje}% del total. Se omitieron ${datosaux.cantidadOmitidos} tipos de trámite de menor frecuencia, que representan en conjunto el ${datosaux.porcentajeOmitido.toFixed(1)}% del total.`
    : "";
     dibujarTextoEnLineas({
      ctx,
      texto:textoAclaratorio,
      x: margenX,
      y: textoAclaratorioY,
      anchoMaximo: canvas.width / 2 - margenX * 2,
      maximoLineas: 3,
      altoLinea: 15,
    }); 

  return canvas.toDataURL(
    "image/png"
  );
};

const crearEncabezadoTabla = (headers) => {
  return headers.map((header) => ({
    text: String(header.label ?? ""),
    bold: true,
    fillColor: "#000000",
    color: "#FFFFFF",
  }));
};

const normalizarFilas = (filas, headers) => {
  return filas.map((fila) =>
    fila.map((valor, indice) => ({
      text: String(valor ?? ""),
      alignment: obtenerAlineacion(
        headers[indice]?.type
      ),
    }))
  );
};

const generatePDF = ({
  headers,
  rows,
  grafico = null,
  tipo,
}) => {
  const header = {
    text:
      tipo === 2
        ? "EXPEDIENTES POR TEMÁTICA"
        : tipo === 1
        ?  "LISTADO DE EXPEDIENTES GENERADOS" : "LISTADO DE EXPEDIENTES",
    alignment: "center",
    margin: [10, 10],
    bold: true,
    fontSize: 18,
  };
  const orientacion =tipo === 2? "portrait": "landscape";
  const footer = (
    currentPage,
    pageCount
  ) => ({
    margin: [40, 20],
    columns: [
      {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: "center",
        color: "gray",
        fontSize:8
      },
      {
        text: `Impresión ${new Date().toLocaleDateString(
          "es-AR"
        )}`,
        fontSize:8,
        alignment: "right",
        color: "gray",
      },
    ],
  });

  const contenido = [];

  if (grafico) {
    contenido.push({
      image: grafico,
      width: 495,
      heigth: "auto",
      alignment: "center",
      margin: [0, 0, 0, 30],
      pageBreak: 'after'
    });

  }
  const totalExpedientes = rows.reduce(
    (acumulado, fila) =>
      acumulado + (Number(fila[1]) || 0),
    0
  );
  const bodyTabla = [
    crearEncabezadoTabla(headers),
    ...normalizarFilas(rows,headers),
  ];
  
  if (tipo === 2) {
    bodyTabla.push([
      {
        text: "TOTAL",
        bold: true,
        alignment: "left",
        fillColor: "#EAEAEA",
        colSpan: 2,
      },
      {},
      {
        text: totalExpedientes.toString(),
        bold: true,
        alignment: "right",
        fillColor: "#EAEAEA",
      },
    ]);
  }
  contenido.push({
    table: {
      headerRows: 1,

      widths:
        tipo === 2
          ? ["*","*", "auto"]
          : [
              "auto",
              "auto",
              "auto",
              "*",
              "*",
            ],

      body:bodyTabla,
    },

    layout: "lightHorizontalLines",
    style: "table",
  });

  const documentDefinition = {
    header,
    content: contenido,

    styles: {
      table: {
        fontSize: 9,
      },
    },

    footer,
    pageMargins: [40, 60, 40, 60],
    pageOrientation: orientacion,
  };

  pdfMake
    .createPdf(documentDefinition)
    .open();
};

const GeneradorPDF = ({
  expedientes = [],
  tipo,
}) => {
  const datosPDF = useMemo(() => {
    if (!Array.isArray(expedientes)) {
      return {
        headers: [],
        rows: [],
        grafico: null,
      };
    }

    if (tipo === 1) {
      return {
        headers: HEADERS_DETALLE,

        rows: expedientes.map(
          (expediente) => [
            expediente.numero_expediente,
            expediente.fecha_inicio,
            expediente.tematica,
            expediente.descripcion_completa,
            expediente.asunto,
          ]
        ),

        grafico: null,
      };
    }
    if (tipo === 3) {
      return {
        headers: HEADERS_DETALLE2,

        rows: expedientes.map(
          (expediente) => [
            expediente.numero_expediente,
            expediente.fecha_inicio,
            expediente.tematica,
            expediente.descripcion_completa,
            expediente.asunto,
          ]
        ),

        grafico: null,
      };
    }

    if (tipo === 2) {
      const datosGrafico =
        expedientes.map((expediente) => ({
          tematica:
            expediente.tematica ??
            "Sin temática",
            digital:expediente.digital,
          cantidad:
            Number(expediente.cantidad) ||
            0,
        }));

      const total = datosGrafico.reduce(
        (acumulado, item) =>
          acumulado + item.cantidad,
        0
      );

      return {
        headers: HEADERS_RESUMEN,

        rows: datosGrafico.map(
          (item) => [
            item.tematica,
            item.digital,
            item.cantidad,
          ]
        ),

        grafico:
          generarGraficoTortaPorcentual(
            "Cantidad de expedientes por temática",
            datosGrafico,
            total
          ),
      };
    }

    return {
      headers: [],
      rows: [],
      grafico: null,
    };
  }, [expedientes, tipo]);

  const generar = () => {
    generatePDF({
      headers: datosPDF.headers,
      rows: datosPDF.rows,
      grafico: datosPDF.grafico,
      tipo,
    });
  };

  return (
    <IconButton
      title="Exportar a PDF"
      onClick={generar}
      disabled={
        datosPDF.rows.length === 0
      }
    >
      <PrintOutlinedIcon />
    </IconButton>
  );
};

export default GeneradorPDF;